import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCartItems, selectCartTotal } from './../../redux/Cart/cart.selectors';
import { createStructuredSelector } from 'reselect';
import './styles.scss';
import Button from './../forms/Button';
import { selectCartItemsCount } from '../../redux/Cart/cart.selectors';
import * as Icon from 'react-feather';
import Item from './Item';

const mapState = createStructuredSelector({
  cartItems: selectCartItems,
  total: selectCartTotal
});

const mapState2 = (state) => ({
  currentUser: state.user.currentUser,
  totalNumCartItems: selectCartItemsCount(state)
});

const Checkout = ({ }) => {
  const history = useHistory();
  const { cartItems, total } = useSelector(mapState);
  const { totalNumCartItems } = useSelector(mapState2);
  var nf = new Intl.NumberFormat();


  const errMsg = 'You have no items in your cart.';

  return (
    <div className='cart-container'>
      <div className="checkout">
        <h1>
          Shopping Cart
        </h1>

        <div className="cart">
          {cartItems.length > 0 ? (
            <table border="0" cellPadding="0" cellSpacing="0">
              <tbody>
                <tr>
                  <td>
                    <table border="0" cellSpacing="0" cellPadding="0">
                      <tbody>
                        {cartItems.map((item, pos) => {
                          return (
                            <tr key={pos}>
                              <td>
                                <Item {...item} />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td>
                    <table border="0" cellSpacing="0" cellPadding="0">
                      <tbody>
                        {/* <tr>
                          <td>
                            <table border="0" cellPadding="10" cellSpacing="0">
                              <tbody>
                                <tr>
                                  <td>
                                    <h3>
                                      Total: {'\u20A6'}{nf.format(total)}
                                    </h3>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr> */}
                        <tr>
                          <td>
                            <table border="0" cellPadding="10" cellSpacing="0">
                              <tbody>
                                <tr>
                                  <td>
                                    <Button onClick={() => history.goBack()}>
                                      Continue Shopping
                                    </Button>
                                  </td>
                                  <td>
                                    <Button onClick={() => history.push('/payment')}>
                                      Checkout
                                    </Button>
                                  </td>
                                </tr>

                                {/* <tr>
                                <td>
                                  <span>
                                    We accept 
                                  </span>
                                  <Icon.Heart/>
                                </td>
                              </tr> */}
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <p>
              {errMsg}
            </p>
          )}
        </div>
      </div>

      <div className='summary-container'>
        <div className='header'>
          <h1>
            Order Summary
          </h1>
        </div>

        <div className='summary-content'>
          <div className='top'>
            <div className='top-content'>
            <span>Items:</span>
            <span className=''>{totalNumCartItems}</span>
            </div>
          </div>

          <div className='top'>
          <div className='top-content'>
          <span className=''>Subtotal:</span>
          <span>{'\u20A6'}{nf.format(total)}</span>
          </div>
        </div>

        <div className='top'>
         <div className='top-content'>
         <span className=''>Delivery Charges:</span>
          <span className='top2'>Add your Delivery address at checkout to see delivery charges</span>
         </div>
        </div>

        <div className='top'>
         <div className='top-content'>
         <span className='top1'>Total:</span>
          <span className='top1'>{'\u20A6'}{nf.format(total)}</span>
         </div>
        </div>
        </div>

      </div>
    </div>
  );
};

export default Checkout;

